import { render } from "./OverlayScene.vue?vue&type=template&id=5dd42884"
import script from "./OverlayScene.vue?vue&type=script&lang=js"
export * from "./OverlayScene.vue?vue&type=script&lang=js"

import exportComponent from "/home/welchome/public_html/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__